/** Shared win/loss/neutral pill styles for game history row layouts. */
export const TEAM_WIN = 'bg-success-light ring-1 ring-success/30';
export const TEAM_LOSS = 'bg-danger-light ring-1 ring-danger/30';
export const TEAM_NEUTRAL = 'bg-surface-subtle ring-1 ring-border-light';

export function teamHighlightClass(isHighlighted, isWin) {
  if (!isHighlighted) return TEAM_NEUTRAL;
  return isWin ? TEAM_WIN : TEAM_LOSS;
}
